<template>
  <div class="cook">
    <div
      id="cookTip"
      class="flex align-center justify-center"
      v-show="!isHide && !thisHide"
    >
      <div class="describe cs">
        本站点使用Cookies，继续浏览表示您同意我们使用Cookies。<a
          @click="link_privacy"
          >Cookies和隐私政策></a
        >
      </div>
      <div
        @click="hideCookiesTip"
        class="btn flex justify-center align-center cs"
      >
        关闭
      </div>
    </div>
    <div id="cookTip-wap" v-show="!isHide && !thisHide">
      <div class="describe cs">
        本站点使用Cookies，继续浏览表示您同意我们使用
        <br />
        Cookies。<a class="link" @click="link_privacy">Cookies和隐私政策></a>
      </div>
      <div
        @click="hideCookiesTip"
        class="btn flex justify-center align-center cs"
      >
        关闭
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie";

export default {
  name: "cookTip",
  data() {
    return {
      isHide: false,
      thisHide: false,
    };
  },
  mounted() {
    const allow_cookies = Cookie.get("allow_cookies");
    const allow_local = localStorage.getItem("allow_local");
    this.isHide = !!allow_cookies;
    this.thisHide = !!allow_local;
  },
  methods: {
    hideCookiesTip() {
      this.isHide = true;
      window._hw("send", "action", "index_privacy_policy_closed");
      Cookie.set("allow_cookies", 1, { expires: 5, path: "*" });
      localStorage.setItem("allow_local", 1);
    },
    //link_privacy 跳转隐私条款
    link_privacy() {
      window._hw("send", "action", "index_privacy_policy_click");
      this.$router.push({
        name: "privacy",
        params: {},
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cook {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: $z-index-cooktip;
  a {
    color: #444444;
    text-decoration: underline;
  }
}
#cookTip {
  display: none;
}

#cookTip-wap {
  display: none;
}

@media screen and (max-width: 992px) {
  #cookTip-wap {
    width: 100%;
    height: 300px;
    background: #fafeff;
    box-shadow: 0px -4px 10px 1px rgba(0, 0, 0, 0.03);
    border-radius: 0 0 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: $z-index-cooktip;
    .link {
      text-decoration: underline;
      text-underline-position: under;
    }

    .describe {
      font-size: 24px;
      font-family: Microsoft YaHei-Light;
      font-weight: 300;
      color: #000000;
      line-height: 36px;
      text-align: center;
    }

    .btn {
      width: 255px;
      height: 60px;
      margin-top: 24px;
      background: #b4251e;
      font-size: 24px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
    }
  }
}

@media screen and (min-width: 992px) {
  //cookTip begin
  #cookTip {
    width: 100%;
    height: 90px;
    background: #fafeff;
    box-shadow: 0px -4px 10px 1px rgba(0, 0, 0, 0.03);
    border-radius: 0 0 0 0;
    opacity: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    .describe {
      font-size: 20px;
      font-family: Microsoft YaHei-Light;
      font-weight: 300;
      color: #000000;
      line-height: 24px;
    }

    .btn {
      width: 120px;
      height: 40px;
      border-radius: 5px;
      background: #b4251e;
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei-Light;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
      margin-left: 112px;
    }

    //coolTip end
  }
}
</style>
